import React from "react";
import axios from "axios";

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export default class Kontakt extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      name: "",
      subject: "",
      email: "",
      text: "",
      globalStatus: "",
      error: {
        name: "",
        subject: "",
        email: "",
        text: "",
      },
    };
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState(
      {
        globalStatus: undefined,
      },
      function () {
        let error = {};

        if (!this.state.name) {
          error.name = "Name darf nicht leer sein.";
        }

        if (!this.state.subject) {
          error.subject = "Name darf nicht leer sein.";
        }

        if (!this.state.text) {
          error.text = "Nachricht darf nicht leer sein.";
        }

        if (!validateEmail(this.state.email)) {
          error.email = "Das Feld muss eine gültige E-Mail Adresse sein.";
        }

        if (!this.state.email) {
          error.email = "E-Mail darf nicht leer sein.";
        }

        this.setState({
          error: error,
        });

        if (!error.name && !error.email && !error.text && !error.subject) {
          axios({
            method: "post",
            url: "https://gehirnpfade.de/wp-content/themes/gehirnpfade-de-theme/contact.php",
            data: this.state,
            config: { headers: { "Content-Type": "multipart/form-data" } },
          })
            .then(
              function (response) {
                if (response.status != 200) {
                  this.setState({
                    globalStatus: {
                      text: "Entschuldigung, es gab ein Fehler beim versenden.",
                      css: "alert alert-danger",
                    },
                  });
                } else {
                  this.setState({
                    globalStatus: {
                      text: "Vielen Dank! Ihre Nachricht wurde erfolgreich versandt.",
                      css: "alert alert-success",
                    },
                  });
                }
              }.bind(this)
            )
            .catch(
              function (error) {
                this.setState({
                  globalStatus: {
                    text: "Entschuldigung, es gab ein Fehler beim versenden.",
                    css: "alert alert-danger",
                  },
                });
              }.bind(this)
            );
        }
      }
    );
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit} id="contact">
        {this.state.globalStatus && <div className={this.state.globalStatus.css}>{this.state.globalStatus.text}</div>}
        <div className="row">
          <div className="form-line col-md-6">
            <label htmlFor="name">Name</label>
            <input type="text" id="name" name="name" value={this.state.name} onChange={this.handleInputChange} />
            <span className="error-label">{this.state.error.name}</span>
          </div>
          <div className="form-line col-md-6">
            <label htmlFor="subject">Betreff</label>
            <input type="text" id="subject" name="subject" value={this.state.subject} onChange={this.handleInputChange} />
            <span className="error-label">{this.state.error.subject}</span>
          </div>
          <div className="form-line col-md-12">
            <label htmlFor="email">E-Mail</label>
            <input type="text" id="email" name="email" value={this.state.email} onChange={this.handleInputChange} />
            <span className="error-label">{this.state.error.email}</span>
          </div>
          <div className="form-line col-md-12">
            <label htmlFor="text">Nachricht</label>
            <textarea id="text" name="text" rows="6" value={this.state.text} onChange={this.handleInputChange}></textarea>
            <span className="error-label">{this.state.error.text}</span>
          </div>
          <div className="spinner" id="contact-spinner">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
          </div>
          <div className="form-line col-md-12">
            <input id="submit" type="submit" value="Senden" />
          </div>
        </div>
      </form>
    );
  }
}
